export const ModalData: string = 'ModalData';
